/* eslint-disabled */

export default class FeatureExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
